import React from "react";

function AllCallsBlocked() {
  return <div>AllCallsBlocked</div>;
}

export default AllCallsBlocked;
